/**
 * @flow
 * @relayHash 7a7f2a3a6df4cd86ea755beee9705d80
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type HomeContentQueriesSystemDocumentTemplateAcceptanceQueryVariables = {||};
export type HomeContentQueriesSystemDocumentTemplateAcceptanceQueryResponse = {|
  +blocSystemDocumentTemplatesAcceptance: ?{|
    +blocSystemDocumentTemplates: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +systemDocumentTemplate: {|
            +pk: ?number,
            +name: string,
            +category: {|
              +name: string
            |},
          |},
          +publishDate: ?string,
          +document: ?{|
            +pk: ?number
          |},
        |}
      |}>,
    |},
    +buckets: ?any,
  |}
|};
export type HomeContentQueriesSystemDocumentTemplateAcceptanceQuery = {|
  variables: HomeContentQueriesSystemDocumentTemplateAcceptanceQueryVariables,
  response: HomeContentQueriesSystemDocumentTemplateAcceptanceQueryResponse,
|};
*/


/*
query HomeContentQueriesSystemDocumentTemplateAcceptanceQuery {
  blocSystemDocumentTemplatesAcceptance {
    blocSystemDocumentTemplates(first: 5) {
      totalCount
      edges {
        node {
          systemDocumentTemplate {
            pk
            name
            category {
              name
              id
            }
            id
          }
          publishDate
          document {
            pk
            id
          }
          id
        }
      }
    }
    buckets
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5,
    "type": "Int"
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishDate",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buckets",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "HomeContentQueriesSystemDocumentTemplateAcceptanceQuery",
  "id": "8b41ef8456b5a5277c7f71eff4b336c3",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "HomeContentQueriesSystemDocumentTemplateAcceptanceQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "blocSystemDocumentTemplatesAcceptance",
        "storageKey": null,
        "args": null,
        "concreteType": "BlocSystemDocumentTemplateListBucketsType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "blocSystemDocumentTemplates",
            "storageKey": "blocSystemDocumentTemplates(first:5)",
            "args": v0,
            "concreteType": "BlocSystemDocumentTemplateCountableConnection",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocSystemDocumentTemplateCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BlocSystemDocumentTemplateType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "systemDocumentTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SystemDocumentTemplateType",
                        "plural": false,
                        "selections": [
                          v2,
                          v3,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CategoryType",
                            "plural": false,
                            "selections": [
                              v3
                            ]
                          }
                        ]
                      },
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v2
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v5
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "HomeContentQueriesSystemDocumentTemplateAcceptanceQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "blocSystemDocumentTemplatesAcceptance",
        "storageKey": null,
        "args": null,
        "concreteType": "BlocSystemDocumentTemplateListBucketsType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "blocSystemDocumentTemplates",
            "storageKey": "blocSystemDocumentTemplates(first:5)",
            "args": v0,
            "concreteType": "BlocSystemDocumentTemplateCountableConnection",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocSystemDocumentTemplateCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BlocSystemDocumentTemplateType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "systemDocumentTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SystemDocumentTemplateType",
                        "plural": false,
                        "selections": [
                          v2,
                          v3,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CategoryType",
                            "plural": false,
                            "selections": [
                              v3,
                              v6
                            ]
                          },
                          v6
                        ]
                      },
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v2,
                          v6
                        ]
                      },
                      v6
                    ]
                  }
                ]
              }
            ]
          },
          v5
        ]
      }
    ]
  }
};
})();
node.text = "query HomeContentQueriesSystemDocumentTemplateAcceptanceQuery {\n  blocSystemDocumentTemplatesAcceptance {\n    blocSystemDocumentTemplates(first: 5) {\n      totalCount\n      edges {\n        node {\n          systemDocumentTemplate {\n            pk\n            name\n            category {\n              name\n              id\n            }\n            id\n          }\n          publishDate\n          document {\n            pk\n            id\n          }\n          id\n        }\n      }\n    }\n    buckets\n  }\n}\n";
(node/*: any*/).hash = '8b693b178709abd3ba34c501d75f3303';
module.exports = node;
